import { useContext } from "react"
import { AvaliacaoDeliveryContext } from "./AvaliacaoDeliveryContext"

export function useAvaliacaoDeliveryContext() {
    return useContext(AvaliacaoDeliveryContext)
}
